import React, { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = "LITSCAN — Know Where to Go Tonight | Real-Time Nightlife Vibe App",
  description = "LITSCAN shows you exactly which bars, clubs, and lounges are lit in real time. Crowdsourced nightlife intelligence — see what's popping, what's dead, and where to go before you pull up.",
  keywords = "nightlife app, bar vibe checker, real-time crowd app, where to go tonight, club scene app, nightlife heatmap, bar busyness app, crowdsourced nightlife, LITSCAN, vibe score app",
  image = "https://litscan.app/og-image.png",
  url = "https://litscan.app/",
  type = "website"
}) => {
  useEffect(() => {
    document.title = title;
    const updateMetaTag = (name: string, content: string, isProperty?: boolean) => {
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let tag = document.querySelector(selector) as HTMLMetaElement;
      if (tag) {
        tag.content = content;
      } else {
        tag = document.createElement('meta');
        if (isProperty) tag.setAttribute('property', name);
        else tag.setAttribute('name', name);
        tag.content = content;
        document.head.appendChild(tag);
      }
    };
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', image, true);
    updateMetaTag('og:url', url, true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('twitter:title', title, true);
    updateMetaTag('twitter:description', description, true);
    updateMetaTag('twitter:image', image, true);

    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (canonicalLink) { canonicalLink.href = url; }
    else {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      canonicalLink.href = url;
      document.head.appendChild(canonicalLink);
    }

    const structuredData = document.createElement('script');
    structuredData.type = 'application/ld+json';
    structuredData.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "LITSCAN",
      "description": "Real-time crowdsourced nightlife vibe app. Know which bars and clubs are lit before you go out.",
      "url": "https://litscan.app",
      "applicationCategory": "Lifestyle",
      "operatingSystem": ["iOS", "Android"],
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
      "author": { "@type": "Organization", "name": "LITSCAN", "url": "https://litscan.app" }
    });
    document.head.appendChild(structuredData);
    return () => { if (structuredData.parentNode) structuredData.parentNode.removeChild(structuredData); };
  }, [title, description, keywords, image, url, type]);

  return null;
};

export default SEO;

